"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What types of lead generation models do you offer?",
  answer: "We specialize in two primary models to suit different business needs: real-time branded campaigns that are tailored specifically to your company, and cost-effective aged leads for scaling your outreach."
}, {
  question: "Which industries do you specialize in?",
  answer: "While we have the capability to work across various sectors, our deep expertise and primary focus lie within the home improvement industry. This includes specialized campaigns for kitchen remodeling, bathroom remodeling, and solar projects."
}, {
  question: "How do branded campaigns differ from aged leads?",
  answer: "Branded campaigns generate exclusive, real-time inquiries from prospects actively seeking your specific services under your brand name. Aged leads are previously generated inquiries that offer a more budget-friendly approach to building your sales pipeline."
}, {
  question: "Are the leads exclusive to my business?",
  answer: "Leads generated through our branded campaigns are 100% exclusive to your business, ensuring you aren't competing with other contractors for the same prospect's attention."
}, {
  question: "How can I get started or learn more about your services?",
  answer: "The best way to get started is to book a demo with our team. We'll discuss your specific goals and how our models can be customized for your business. You can also reach out to our sales team directly at success@axeboxmedia.com."
}];
export default function CommonQuestions() {
  return <section id="common-questions" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-4xl">
        <div className="mb-16 text-center md:text-left">
          <h2 className="text-3xl font-bold tracking-tight md:text-5xl lg:text-6xl">
            Common <span className="text-primary">Questions</span>
          </h2>
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl">
            Everything you need to know about our lead generation models and how we help home improvement businesses scale.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-6">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border-b-4 border-border px-6 py-2 rounded-sm shadow-sm transition-colors hover:border-primary/50 data-[state=open]:border-primary">
              <AccordionTrigger className="text-left text-lg font-semibold hover:no-underline hover:text-primary transition-colors py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent>
                <div className="border-l-4 border-primary pl-5 py-2 mt-2 mb-4 text-base leading-relaxed text-muted-foreground bg-background/50 rounded-r-sm">
                  {faq.answer}
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 flex flex-col items-center justify-center gap-4 text-center md:flex-row md:justify-between md:text-left bg-card p-8 rounded-lg border border-border">
          <div>
            <h3 className="text-xl font-bold">Still have questions?</h3>
            <p className="text-muted-foreground mt-1">
              Our team is ready to provide the answers you need.
            </p>
          </div>
          <div className="flex gap-4">
            <Button asChild variant="outline" size="lg">
              <Link to="/ConnectWithUsPage">Contact Support</Link>
            </Button>
            <Button asChild size="lg">
              <Link to="/ReserveYourDemoPage">Book a Demo</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}